module.exports = __webpack_public_path__ + "img/friendly-platform.6d3125d4.png";